export const AUTH_STORAGE_KEY = 'icmec-auth';